/**
 * Максимальное количество регионов в строке-витрине списка регионов страны.
 */
export const maxLength = 8;
